module.exports = __webpack_public_path__ + "assets/LogoBfS.44758eb8.svg";